import React, { PureComponent } from 'react';
import { PropTypes as T } from 'prop-types';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

export default class PageHeader extends PureComponent {
  static defaultProps = {
    links: [],
  }

  static propTypes = {
    name: T.string.isRequired,
    links: T.arrayOf(T.shape({ name: T.string, href: T.string })),
    children: T.oneOfType([
      T.arrayOf(T.node),
      T.node,
    ]),
  }

  render() {
    return (
      <div className="my-4">
        <div className="justify-content-between d-flex">
          <div className="d-flex">
            <h4 className="m-0 mr-3">{this.props.name}</h4>
            <span>
              {this.props.links.map(link => (
                <span key={link.href}><a href={link.href} className="btn btn-sm btn-clear d-none d-md-inline-block" target="_blank">{link.name}</a> </span>
              ))}
              {this.props.children}
            </span>
          </div>
          <UncontrolledDropdown>
            <DropdownToggle tag="a" href="#" caret>
              <i className="fa fa-life-ring" /> Help
            </DropdownToggle>
            <DropdownMenu right>
              <DropdownItem href="/docs/api">Documentation</DropdownItem>
              <DropdownItem href="/knowledgebase">Knowledge Base</DropdownItem>
              <DropdownItem href="/support">Support</DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/page_header_react/index.jsx